import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchProjectTodo = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/todos`);

export const addProjectTodo = ({ accountId, branchId, projectId, ...params }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/todos`, params);

export const updateProjectTodo = ({ accountId, branchId, projectId, todoId, ...params }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/todos/${todoId}`, params);

export const deleteProjectTodo = ({ accountId, branchId, projectId, todoId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/todos/${todoId}`);
